import axios from 'axios';
import { setCookie, getCookie, deleteCookie } from './cookieUtils'; 
import { getAppUrlInfo } from './urls';

/**
 * Returns the appropriate domain based on the environment.
 * - In production: '.parkinglap.com'
 * - In development: 'localhost'
 */ 
export const setAuthSession = (user: any, lastTokenUpdate: boolean = true) => {
  if (lastTokenUpdate) {
    setCookie('lastTokenUpdate', Date.now().toString());
  }
  setCookie('user', JSON.stringify(user));
};

export const clearAuthSession = () => {
  deleteCookie('user');
  deleteCookie('lastTokenUpdate');
};

export const getCurrentUser = (): any | null => {
  const user = getCookie('user');
  return user ? JSON.parse(user) : null;
};

export const getCurrentUserId = (): string | null =>
  getCurrentUser()?._id || null;

export const isAuthenticated = (): boolean => {
  try {
    const user = getCookie('user');
    return user ? JSON.parse(user).email : false;
  } catch {
    return false;
  }
};

/**
 * Returns the base URL for accounts API.
 */ 

export const handleLogout = () => {
  const {accountsApiUrl, accountsUrl,currentUrl} =  getAppUrlInfo();

  // ✅ clears HttpOnly cookie
  try {
    axios({
      method: 'get',
      //url: ACCOUNTS_API_PATHS.userLogout,
      url: `${accountsApiUrl}/auth/logout`,
      withCredentials: true,
    });
  } catch (err) {
    console.warn('Logout API failed — continuing local logout', err);
  }
  clearAuthSession(); 
  window.location.href = `${accountsUrl}/login?backTo=${currentUrl}`;
};

/**
 * Gets the last token update timestamp from cookies.
 */
export const getLastTokenUpdate = (): number | null => {
  const lastTokenUpdateStr = getCookie('lastTokenUpdate');
  return lastTokenUpdateStr ? parseInt(lastTokenUpdateStr, 10) : null;
};

/**
 * Updates the last token update timestamp in cookies.
 */
export const updateLastTokenUpdate = () => {
  setCookie('lastTokenUpdate', Date.now().toString());
};
